import config from "../utils/config";
import EN from "./en.json";
import ES from "./es.json";
import UA from "./ua.json";
export const defaultLocale = "EN";
const S3_BASE_URL =  config.APP_LANGUAGE;

function applyBrand(messages) {
  const brand = (config.brand && config.brand.name) || "RPay";
  if (!messages) {
    return messages;
  }
  const out = {};
  Object.keys(messages).forEach((key) => {
    const value = messages[key];
    if (typeof value !== "string") {
      out[key] = value;
      return;
    }
    let next = value
      .replace(/RocketFuelInc/g, "___PAY_ID___")
      .replace(/RocketFuel Blockchain Inc\./g, "___LEGAL_RF___")
      .replace(/Rocketfuel Blockchain Inc\.?/g, "___LEGAL_rf___")
      .replace(/RocketFuel/g, brand)
      .replace(/Rocketfuel/g, brand)
      .replace(/Rocket Fuel/g, brand)
      .replace(/___LEGAL_RF___/g, "RocketFuel Blockchain Inc.")
      .replace(/___LEGAL_rf___/g, "Rocketfuel Blockchain Inc.")
      .replace(/___PAY_ID___/g, "RocketFuelInc");
    if (brand !== "RPay") {
      next = next.replace(/RPay/g, brand);
    }
    out[key] = next;
  });
  return out;
}

export const localLanguages = {
  EN: applyBrand(EN),
  ES: applyBrand(ES),
  UA: applyBrand(UA),
}
export const languages = {
  EN: {
    url: `${S3_BASE_URL}/en.json`,
    id: "EN",
  },
  ES: {
    url: `${S3_BASE_URL}/es.json`,
    id: "ES",
  },
  UA: {
    url: `${S3_BASE_URL}/ua.json`,
    id: "UA",
  },
};

export const loadLanguageResources = async (locale) => {
  try {
    if(config.DYNAMIC_I18N) {
      const language = languages[locale];
      if (!language) throw new Error(`Language ${locale} not supported.`);
      
      const response = await fetch(language.url);
      if (!response.ok) throw new Error("Failed to fetch language resources.");
      
      const resources = await response.json();
      return applyBrand(resources);
    } else {
      return localLanguages[locale]
    }

  } catch (error) {
    console.error(`Error loading language resources: ${error.message}`);
    return localLanguages[locale]; // fallback from local
  }
};
